import { useState, useEffect } from "react";

export const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(query);
    if (media.matches !== matches) {
      setMatches(media.matches);
    }
    const listener = () => setMatches(media.matches);
    window.addEventListener("resize", listener);
    return () => window.removeEventListener("resize", listener);
  }, [matches, query]);

  return matches;
};

export const useRemoveSessionStore = (keysSessions = []) => {
  useEffect(() => {
    const handleBeforeUnload = () => {
      const currentKeys = [
        "selected",
        "ratesSelectedTime",
        "sedeId",
        "fieldId",
        ...keysSessions,
      ];
      currentKeys.forEach((keys) => {
        sessionStorage.removeItem(keys);
      });
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [keysSessions]);

  return;
};
